import {ChecklistModel} from './checklistModel.model';
import {User} from './user.model';
import {ChecklistAnswerGroup} from './checklistAnswerGroup.model';
import {Client} from './client.model';

export class Checklist {
    id: number;
    state: string;
    stateLabel: string;
    targetDate: string;
    completionDate: string;
    groupsCount: number;
    completedCount: number;
    checklistModel: ChecklistModel;
    user: User;
    client: Client;
    assessmentId: number;
    algorithmId: number;
    groups: Array<ChecklistAnswerGroup> = [];
    createdDate: string;

    constructor(checklist: any) {
        if (checklist) {
            this.id = checklist.id;
            this.state = checklist.state;
            this.stateLabel = checklist.stateLabel;
            this.targetDate = checklist.targetDate;
            this.completionDate = checklist.completionDate;
            this.groupsCount = checklist.groupsCount;
            this.completedCount = checklist.completedCount;
            this.checklistModel = new ChecklistModel(checklist.checklistModel);
            this.user = new User(checklist.user);
            this.client = new Client(checklist.client);
            this.assessmentId = checklist.assessmentId;
            this.algorithmId = checklist.algorithmId;
            if (checklist.groups) {
                checklist.groups.forEach(group => {
                    this.groups.push(new ChecklistAnswerGroup(group));
                });
            }
            this.createdDate = checklist.createdDate;
        }
    }
}
